import { FormattedMessage } from 'react-intl';

const Release620 = () => (
    <div style={{ marginLeft: '110px' }}>
        <p className="text-bold text-size-18 margin-bottom-5">
            <FormattedMessage id="help.changelog.6.2.0.featureName" />
        </p>
        <p className="margin-top-0 margin-bottom-5">
            <FormattedMessage id="help.changelog.6.2.0.releaseDetail.title" />
        </p>
        <ul>
            <li>
                <FormattedMessage id="help.changelog.6.2.0.releaseDetail.one" />
            </li>
            <li>
                <FormattedMessage id="help.changelog.6.2.0.releaseDetail.two" />
            </li>
            <li>
                <FormattedMessage id="help.changelog.6.2.0.releaseDetail.three" />
            </li>
        </ul>
    </div>
);

export default Release620;
